import { useEffect } from "react";
import Lenis from "lenis";

export const scrollToSection = (hash) => {
  const lenis = window.__lenis;
  if (lenis) lenis.scrollTo(hash, { offset: -96, duration: 1.3 });
  else document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
};

const SmoothScroll = ({ children }) => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return <>{children}</>;
};

export default SmoothScroll;
